module.exports = __webpack_public_path__ + "img/wintermute.e7fc7752.svg";